export const PROFESSIONAL = {
  url: 'https://www.coches.net/registro-profesionales/',
  proUrl: 'https://pro.coches.net/'
}

export const SOCIAL_MEDIA_IDS = {
  FACEBOOK: 'facebook',
  TWITTER: 'twitter',
  INSTAGRAM: 'instagram',
  YOUTUBE: 'youtube',
  TIKTOK: 'tiktok',
  LINKEDIN: 'linkedin'
}

export const social = [
  {
    url: 'https://www.facebook.com/Coches.net',
    text: SOCIAL_MEDIA_IDS.FACEBOOK
  },
  {
    url: 'https://twitter.com/Cochesnet',
    text: SOCIAL_MEDIA_IDS.TWITTER
  },
  {
    url: 'https://www.instagram.com/cochesnetoficial',
    text: SOCIAL_MEDIA_IDS.INSTAGRAM
  },
  {
    url: 'https://www.youtube.com/user/cochesnet',
    text: SOCIAL_MEDIA_IDS.YOUTUBE
  },
  {
    url: 'https://www.tiktok.com/@coches.net',
    text: SOCIAL_MEDIA_IDS.TIKTOK
  },
  {
    url: 'https://es.linkedin.com/company/coches-net',
    text: SOCIAL_MEDIA_IDS.LINKEDIN
  }
]

export const stores = {
  itunes: {
    url: 'https://itunes.apple.com/es/app/coches.net/id333895109',
    text: 'iTunes'
  },
  gplay: {
    url: 'https://play.google.com/store/apps/details?id=coches.net',
    text: 'Google Play'
  }
}
